import { connect } from 'react-redux'
import { IStoreState } from '../../types/index'
import AddMakeModal from 'src/components/global-settings/AddMakeModal'
import { createVehicleMake, getVehicleCreateOptions } from 'src/state/actions/vehicles'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {}
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    createVehicleMake: (name: string) => {
      return new Promise((approve, reject) => {
        dispatch(createVehicleMake(name)).then(() => {
          dispatch(getVehicleCreateOptions()).then(() => {
            approve()
          })
        })
      })
    },
    getVehicleCreateOptions: () => dispatch(getVehicleCreateOptions())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddMakeModal)



// WEBPACK FOOTER //
// ./src/containers/global-settings/AddMakeModal.ts